/* eslint-disable react/state-in-constructor */
/* eslint-disable react/prop-types */
import React, { Component, Suspense } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Operations from '../../../operations'
import Actions from '../../../actions'
import { isEqual, chain } from 'lodash'
import Form from '../../../components/forms'
import {
  PREFERRED_TERM_RES_OPTIONS,
  PREFERRED_TERM_CARE_OPTIONS,
  EVERYONE_BUTTON,
  SORT_BY_ROOM_NR_OPTIONS,
  GPS_LOCATION,
  DEVICE_ACCESS_OPTIONS,
  PREFERRED_SERVICE_OPTIONS,
} from '../../../common/constants'
import { colors, sizes } from '@lmc/common/constants'
import Field from '../../../components/fields'
import { isBrowser, isTablet } from 'react-device-detect'
import {
  SectionHeader,
  AccessRestriction,
  SubTitle,
} from '../../../components/generic'
import { getNominative, openDialog, showToast } from '../../../common/utils'
import RoundTimings from './components/RoundTimings'
import Glyph from '../../../LEGACY/Glyph'
import { ButtonOLD } from '@lmc/ui-kit'
import { MoreInfoLink, Text } from '@lmc/ui-kit/src/general'
import { colours } from '@lmc/ui-kit/src/config/theme'
import { Link } from 'react-router-dom'
import { getJSON } from 'common/services/api'
import { CarePlanPreferences } from './components'
import { Trans } from 'react-i18next'
import { QuickLogSettings } from './components/QuickLogSettings'

export class HomeSettingsScreen extends Component {
  state = {
    saveButtonTitle: 'Save Changes',
    deviceAccessControl: undefined,
    shifts: undefined,
    noticeBoard: undefined,
    bedCapacityActive: undefined,
    allowVideoUpload: undefined,
    photos: undefined,
    positiveBehaviour: undefined,
  }

  componentDidMount() {
    const { addForm, homeSettings, refreshLists, features } = this.props
    addForm(homeSettings)
    if (features) {
      this.setState((prevState) => ({
        ...prevState,
        deviceAccessControl: features?.deviceAccessControl?.enabled,
        shifts: features?.shifts?.enabled,
        noticeBoard: features?.noticeBoard?.enabled,
        allowVideoUpload: features?.allowVideoUpload?.enabled,
        photos: features?.photos?.enabled,
        positiveBehaviour: features?.positiveBehaviour?.enabled,
      }))
    }
    refreshLists()

    if (
      features &&
      features?.bedOccupancy?.granted &&
      !this.state.bedCapacityActive
    ) {
      this.fetchMedicationsList()
    }
  }

  componentDidUpdate(prevProps) {
    const { fields, setHomeDetails, features } = this.props
    if (prevProps.fields && !isEqual(prevProps.fields, fields)) {
      for (const key in fields) {
        if (fields[key] !== prevProps.fields[key]) {
          setHomeDetails({
            key,
            value: fields[key],
          })
        }
      }
    }

    if (
      features &&
      (this.state.deviceAccessControl === undefined ||
        this.state.shifts === undefined ||
        this.state.noticeBoard === undefined ||
        this.state.allowVideoUpload === undefined ||
        this.state.photos === undefined ||
        this.state.positiveBehaviour === undefined)
    ) {
      this.setState((prevState) => ({
        ...prevState,
        deviceAccessControl: features?.deviceAccessControl?.enabled,
        shifts: features?.shifts?.enabled,
        noticeBoard: features?.noticeBoard?.enabled,
        allowVideoUpload: features?.allowVideoUpload?.enabled,
        photos: features?.photos?.enabled,
        positiveBehaviour: features?.positiveBehaviour?.enabled,
      }))
    }
  }

  componentWillUnmount() {
    if (this.props.user.home?.id) {
      this.props.getHomeDetails(this.props.user.home)
      this.props.remove({})
    }
    this.setState((prevState) => ({
      ...prevState,
    }))
  }

  onClickHandler = async () => {
    const { homeSettings, refreshLists, saveSettings, clear, features } =
      this.props
    await saveSettings({
      ...homeSettings,
      features: {
        ...features,
        deviceAccessControl: {
          granted: features?.deviceAccessControl?.granted,
          enabled: this.state?.deviceAccessControl,
        },
        shifts: {
          granted: features?.shifts?.granted,
          enabled: this.state?.shifts,
        },
        noticeBoard: {
          granted: features?.noticeBoard?.granted,
          enabled: this.state?.noticeBoard,
        },
        allowVideoUpload: {
          granted: features?.allowVideoUpload?.granted,
          enabled: this.state?.allowVideoUpload,
        },
        photos: {
          granted: features?.photos?.granted,
          enabled: this.state?.photos,
        },
        positiveBehaviour: {
          granted: features?.positiveBehaviour?.granted,
          enabled: this.state?.positiveBehaviour,
        },
      },
    })
    refreshLists()
    clear()
    showToast({ title: 'Saved' })
  }

  renderQuickLogSettings = () => {
    const { homeSettings } = this.props
    return (
      <div style={{ paddingBottom: 50 }}>
        <SectionHeader title="Log Options" />
        <div>
          <span style={styles.preferred_subTitle1}>
            In the App, we have a default list of daily logs that cover most
            areas of care. If you would prefer your staff not use some daily
            logs, toggle them off and they will no longer appear in the Daily
            Logs section of the App. You’ll need to log out of the App and log
            back in to see any changes that have been made.
            <a
              target="_blank"
              href="https://support.logmycare.co.uk/en/articles/3853371-how-can-i-hide-log-options"
              rel="noreferrer"
            >
              {' '}
              Find out more
            </a>
          </span>
        </div>
        <div>
          <QuickLogSettings homeSettings={homeSettings} formId={FORM_ID} />
        </div>
      </div>
    )
  }

  renderSortByRoomNrSettings = (homeSettings) => {
    const preferredResidentTerm = getNominative(
      homeSettings.preferredPeopleNominative,
      'Resident'
    )
    return (
      <div style={{ paddingBottom: 50 }}>
        <SectionHeader title={`${preferredResidentTerm}s List`} />
        <div>
          <span style={styles.preferred_subTitle1}>
            {`Choose to have ${preferredResidentTerm} lists sorted alphabetically (A-Z) or by room number (1,2,3...). This will affect `}
            <span style={{ fontWeight: 'bolder' }}>all</span>
            {` ${preferredResidentTerm} lists in the Care Office and in
                        the App, including the ${preferredResidentTerm} page, Handovers and all Reports.`}
          </span>
        </div>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            keys="sortByRoomNumber"
            label=""
            layout="no-label"
            displayLabel={false}
            formId={FORM_ID}
            type="radios"
            options={SORT_BY_ROOM_NR_OPTIONS}
            values={homeSettings}
          />
        </Suspense>
      </div>
    )
  }

  fetchMedicationsList = async () => {
    try {
      const json = await getJSON({
        url: `/api/aggregations/bed-occupancy`,
      })
      this.setState((prevState) => ({
        ...prevState,
        bedCapacityActive: json.result.active,
      }))
    } catch (e) {
      console.log(e)
    }
  }

  render() {
    const {
      homeSettings,
      openNewRoundTimingModal,
      deleteRoundTiming,
      roundTimings,
      pro,
      features,
    } = this.props
    const { saveButtonTitle } = this.state

    const shiftsGranted = features?.shifts?.granted

    const noticeboardGranted = features?.noticeBoard?.granted

    const deviceAccessControlGranted = features?.deviceAccessControl?.granted

    const occupancyGranted = features?.bedOccupancy?.granted

    const allowVideoUploadGranted = features?.allowVideoUpload?.granted

    const photosGranted = features?.photos?.granted

    const positiveBehaviourGranted = features?.positiveBehaviour?.granted

    const positiveBehaviourEnabled = features?.positiveBehaviour?.enabled

    if (!homeSettings) return null

    const appImgUrl = homeSettings.showAllResidentsButton
      ? APP_SEE_EVERYONE
      : APP_HIDE_EVERYONE

    return (
      <div style={styles.container}>
        {pro && (
          <div style={{ paddingBottom: 64 }}>
            <SectionHeader title="GPS Location" />
            <div>
              <span style={styles.preferred_subTitle1}>
                <Trans>LOCATION_SETTINGS_TITLE</Trans>
              </span>
            </div>
            <div>
              <span style={styles.preferred_subTitle1}>
                Once enabled, your carers will be asked to allow Log my Care to
                track their location while using the Carer App.{' '}
                <strong>
                  Please advise your carers to allow this, otherwise the
                  location won't be recorded.
                </strong>
              </span>
            </div>
            <div style={{ paddingTop: 8 }}>
              <Suspense fallback={<div>Loading...</div>}>
                <Field
                  keys="geoLocation"
                  label=""
                  layout="no-label"
                  displayLabel={false}
                  formId={FORM_ID}
                  type="radios"
                  options={GPS_LOCATION}
                  values={homeSettings}
                />
              </Suspense>
            </div>
          </div>
        )}
        <SectionHeader title="Preferred Terms" />
        <div>
          <span style={styles.preferred_subTitle1}>{PREFERRED_SUBTITLE}</span>
        </div>
        <div style={styles.headingWrapper}>
          <SubTitle subTitle="The term for people you support" />
          <div style={{ paddingTop: 8 }}>
            <Suspense fallback={<div>Loading...</div>}>
              <Field
                keys="preferredPeopleNominative"
                label=""
                layout="no-label"
                displayLabel={false}
                formId={FORM_ID}
                type="radios"
                options={PREFERRED_TERM_RES_OPTIONS}
                values={homeSettings}
              />
            </Suspense>
          </div>
        </div>
        <div style={{ paddingBottom: 64 }}>
          <SubTitle subTitle="The term for their personalised care and support plan" />
          <div style={{ paddingTop: 8 }}>
            <Suspense fallback={<div>Loading...</div>}>
              <Field
                keys="preferredCarePlansNominative"
                label=""
                layout="no-label"
                displayLabel={false}
                formId={FORM_ID}
                type="radios"
                options={PREFERRED_TERM_CARE_OPTIONS}
                values={homeSettings}
              />
            </Suspense>
          </div>
        </div>
        <div style={{ paddingBottom: 64 }}>
          <SubTitle subTitle="What is the correct term for your service: LPS or DoLS?" />
          <div style={{ paddingTop: 8 }}>
            <Suspense fallback={<div>Loading...</div>}>
              <Field
                keys="preferredServiceName"
                label=""
                layout="no-label"
                displayLabel={false}
                formId={FORM_ID}
                type="radios"
                options={PREFERRED_SERVICE_OPTIONS}
                values={homeSettings}
              />
            </Suspense>
          </div>
        </div>
        {occupancyGranted && (
          <>
            <SectionHeader title="Bed capacity" />
            <div>
              <span style={styles.preferred_subTitle1}>
                The number of beds and service user data will allow you to
                better understanding the occupancy of your services at the
                moment and over time. Once the capacity is set, explore
                <Link to="/reports/occupancy-report">{` Occupancy report here.`}</Link>
              </span>
            </div>
            <div style={{ flexDirection: 'row', marginBottom: 48 }}>
              <Suspense fallback={<div>Loading...</div>}>
                <Field
                  keys="bedCapacity"
                  layout="no-label"
                  type="number"
                  positiveValuesOnly
                  displayLabel={false}
                  formId={FORM_ID}
                  values={homeSettings}
                  minValue={this.state.bedCapacityActive}
                />
              </Suspense>
            </div>
          </>
        )}
        {this.renderSortByRoomNrSettings(homeSettings)}
        <SectionHeader title="App Privacy Settings" />
        <div style={styles.appPrivacySettings}>
          {isDesktop && (
            <div style={styles.appPrivacyImg}>
              <img alt="" style={{ width: 326, height: 316 }} src={appImgUrl} />
            </div>
          )}
          <div style={styles.appPrivacyDescription}>
            <SubTitle subTitle="‘See Everyone’ button" />
            <span style={styles.preferred_subTitle1}>
              {APP_PRIVACY_SUBTITLE1}
              <AccessRestriction>
                <a
                  href={SUPPORT_ARTICLE}
                  style={{ paddingLeft: 5 }}
                  target="_blank"
                  rel="noreferrer"
                >
                  Find out more
                </a>
              </AccessRestriction>
            </span>
            <span style={styles.preferred_subTitle1}>
              {APP_PRIVACY_SUBTITLE2}
            </span>
            <div style={{ paddingTop: 20 }}>
              <Suspense fallback={<div>Loading...</div>}>
                <Field
                  keys="showAllResidentsButton"
                  label=""
                  layout="no-label"
                  displayLabel={false}
                  formId={FORM_ID}
                  type="radios"
                  options={EVERYONE_BUTTON}
                  values={homeSettings}
                />
              </Suspense>
            </div>
          </div>
        </div>
        {(allowVideoUploadGranted || photosGranted) && (
          <div style={{ paddingBottom: 64 }}>
            <SectionHeader title="More Privacy Settings" />
            <div style={{ paddingTop: 8 }}>
              {allowVideoUploadGranted && (
                <Suspense fallback={<div>Loading...</div>}>
                  <Field
                    keys="allowVideoUpload"
                    label="Allow carers to upload video"
                    formId={FORM_ID}
                    type="switch"
                    values={this.state}
                    onChange={(value) =>
                      this.setState((prevState) => ({
                        ...prevState,
                        allowVideoUpload: value,
                      }))
                    }
                    options={{ on: { value: true }, off: { value: false } }}
                  />
                </Suspense>
              )}
              {photosGranted && (
                <Suspense fallback={<div>Loading...</div>}>
                  <Field
                    keys="photos"
                    label="Allow carers to upload photos"
                    formId={FORM_ID}
                    type="switch"
                    values={this.state}
                    onChange={(value) =>
                      this.setState((prevState) => ({
                        ...prevState,
                        photos: value,
                      }))
                    }
                    options={{ on: { value: true }, off: { value: false } }}
                  />
                </Suspense>
              )}
            </div>
          </div>
        )}
        {(deviceAccessControlGranted || shiftsGranted) && (
          <div style={{ paddingBottom: 64, maxWidth: 720 }} id="access-control">
            {deviceAccessControlGranted && (
              <>
                <SectionHeader title="Access Control" />
                <div>
                  <span>{DEVICE_ACCESS_CONTROL_SUBTITLE}</span>
                </div>
                <>
                  <div style={styles.headingWrapper}>
                    <div style={styles.descriptionWrapper}>
                      <SubTitle subTitle="Enable Device Access Control?" />
                      <div style={styles.gap}>
                        <MoreInfoLink helpArticleUrl="https://support.logmycare.co.uk/en/articles/8081503-how-to-get-started-with-device-access-control" />
                      </div>
                    </div>
                    <div style={{ paddingTop: 8 }}>
                      <Suspense fallback={<div>Loading...</div>}>
                        <Field
                          keys="deviceAccessControl"
                          label=""
                          layout="no-label"
                          displayLabel={false}
                          formId={FORM_ID}
                          type="radios"
                          options={DEVICE_ACCESS_OPTIONS}
                          values={this.state}
                          onChange={(value) =>
                            this.setState((prevState) => ({
                              ...prevState,
                              deviceAccessControl: value,
                            }))
                          }
                        />
                      </Suspense>
                    </div>
                  </div>
                  <Text level={2} style={{ color: colours.neutral.color4 }}>
                    If this is your first time enabling Device Access control,
                    please check our guide in the question mark above. There are
                    tips and email templates to help you communicate security
                    changes with your team.
                  </Text>
                </>
              </>
            )}
            {shiftsGranted && (
              <div style={styles.headingWrapper}>
                <div style={{ display: 'flex', alignItems: 'baseline' }}>
                  <SubTitle subTitle="Enable Shift Passwords?" />
                  <div style={styles.gap}>
                    <MoreInfoLink helpArticleUrl="https://support.logmycare.co.uk/en/articles/1553777-how-do-i-set-up-a-shift-password" />
                  </div>
                </div>
                <div style={{ paddingTop: 8 }}>
                  <Suspense fallback={<div>Loading...</div>}>
                    <Field
                      keys="shifts"
                      label=""
                      layout="no-label"
                      displayLabel={false}
                      formId={FORM_ID}
                      type="radios"
                      options={DEVICE_ACCESS_OPTIONS}
                      values={this.state}
                      onChange={(value) =>
                        this.setState((prevState) => ({
                          ...prevState,
                          shifts: value,
                        }))
                      }
                    />
                  </Suspense>
                </div>
              </div>
            )}
            {pro && noticeboardGranted && (
              <div style={styles.noticeBoardWrapper}>
                <SectionHeader title="Noticeboard" />
                <div>
                  <span style={styles.preferred_subTitle1}>
                    Noticeboard is a valuable tool for keeping your care team
                    up-to-date on upcoming events, inspections, and new team
                    members. Simply click &apos;Yes&apos; to activate the
                    Noticeboard feature and stay connected.
                  </span>
                </div>
                <div style={styles.headingWrapper}>
                  <div style={{ display: 'flex', alignItems: 'baseline' }}>
                    <SubTitle subTitle="Enable Noticeboard?" />
                    <div style={styles.gap}>
                      <MoreInfoLink helpArticleUrl="https://support.logmycare.co.uk/en/articles/8117538-the-noticeboard" />
                    </div>
                  </div>
                  <div style={{ paddingTop: 8 }}>
                    <Suspense fallback={<div>Loading...</div>}>
                      <Field
                        keys="noticeBoard"
                        label=""
                        layout="no-label"
                        displayLabel={false}
                        formId={FORM_ID}
                        type="radios"
                        options={DEVICE_ACCESS_OPTIONS}
                        values={this.state}
                        onChange={(value) =>
                          this.setState((prevState) => ({
                            ...prevState,
                            noticeBoard: value,
                          }))
                        }
                      />
                    </Suspense>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {homeSettings.eMAR && (
          <RoundTimings
            deleteRoundTiming={deleteRoundTiming}
            homeName={homeSettings.name}
            openNewRoundTimingModal={openNewRoundTimingModal}
            roundTimings={roundTimings}
          />
        )}
        <CarePlanPreferences
          positiveBehaviourGranted={positiveBehaviourGranted}
          positiveBehaviourEnabled={this.state.positiveBehaviour}
          onTooglePositiveBehaviour={(checked) => {
            if (checked) {
              this.setState({ positiveBehaviour: true })
            } else {
              this.setState({ positiveBehaviour: false })
            }
          }}
        />
        {this.renderQuickLogSettings()}
        <AccessRestriction>
          <div
            className="lmc-fixed-footer"
            style={{
              ...styles.footer,
            }}
          >
            <ButtonOLD
              type="primary"
              onClick={() => {
                this.onClickHandler()
              }}
              icon={<Glyph name="check" />}
            >
              {saveButtonTitle}
            </ButtonOLD>
          </div>
        </AccessRestriction>
      </div>
    )
  }
}

const PREFERRED_SUBTITLE =
  'By changing a term, it will change everywhere in the Care Office and App where it is mentioned. Any changes made will automatically be updated in the Care Office. For the App, you will need to log out and log back in to see the changes.'
const APP_PRIVACY_SUBTITLE1 =
  'Choosing to hide the ‘Show Everyone’ button in the App will mean that Team Members will be restricted to only access clients they have been assigned to. This option is most likely to be helpful in domiciliary care and supported living.'
const APP_PRIVACY_SUBTITLE2 =
  "Please note: if you are using our Pro Plan, choosing to hide this button will disable the app's handovers feature."
const APP_SEE_EVERYONE =
  'https://lmc-data-production.s3.eu-west-2.amazonaws.com/public/app-privacy-image.png'
const APP_HIDE_EVERYONE =
  'https://lmc-data-production.s3.eu-west-2.amazonaws.com/public/app-privacy-image-hide.png'
const SUPPORT_ARTICLE =
  'https://support.logmycare.co.uk/en/articles/1553743-how-do-i-assign-only-certain-carers-to-a-resident'
const FORM_ID = 'home-settings'
const DEVICE_ACCESS_CONTROL_SUBTITLE =
  'Device access control helps prevent unauthorised access to sensitive information, protects against malware or other malicious activities. You can manage which mobile and tablet devices can access the Carer App, and staff will only be able to log into the app on verified devices.'

HomeSettingsScreen.propTypes = {
  user: PropTypes.object,
}

const isDesktop = isBrowser || isTablet

const styles = {
  container: {
    margin: '0 auto',
    maxWidth: sizes.childScreen,
    padding: '24px 24px',
  },
  preferred_subTitle1: {
    color: colors.black,
    display: 'block',
    marginTop: 25,
  },
  buttonGray: {
    background: colors.grey,
    color: 'white',
    padding: '0px 25px',
    marginLeft: 10,
    textShadow: 'none',
  },
  buttonGreen: {
    background: colors.successgreen,
    color: 'white',
    padding: '0px 25px',
    marginLeft: 10,
    textShadow: 'none',
  },
  appPrivacySettings: {
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 40,
  },
  appPrivacyImg: {
    paddingTop: 10,
  },
  appPrivacyDescription: {
    marginTop: -12,
  },
  footer: {
    border: 'none',
    background: 'white',
    display: 'flex',
    justifyContent: isDesktop ? 'flex-end' : 'space-between',
    width: isBrowser || isTablet ? 'calc(100vw - 290px)' : '100vw',
  },
  headingWrapper: {
    paddingBottom: 8,
  },
  noticeBoardWrapper: {
    marginTop: 48,
  },
  descriptionWrapper: { display: 'flex', alignItems: 'baseline' },
  gap: { marginLeft: 5 },
}

const mapStateToProps = (state) => {
  const {
    showAllResidentsButton,
    preferredPeopleNominative,
    preferredCarePlansNominative,
    preferredServiceName,
    sortByRoomNumber,
    logCategoryItems,
    eMAR,
    id,
    name,
    pro,
    geoLocation,
    bedCapacity,
    features,
  } = state.global.home

  return {
    roundTimings: chain(state.data['emar-round-timings'])
      .filter({ deleted: false })
      .orderBy('time')
      .value(),
    homeSettings: {
      showAllResidentsButton,
      preferredPeopleNominative,
      preferredCarePlansNominative,
      preferredServiceName,
      preferencesCustomised: true, // keep track if the user has changed the preferences
      logCategoryItems,
      sortByRoomNumber,
      eMAR,
      id,
      name,
      geoLocation,
      bedCapacity,
    },
    features,
    pro,
  }
}

const mapDispatchToProps = (dispatch) => ({
  setHomeDetails: ({ key, value }) =>
    dispatch(Actions.setHomeDetails({ key, value })),
  getHomeDetails: (homeSettings) =>
    dispatch(Operations.getHomeDetails(homeSettings.id)),
  refreshLists: () => {
    dispatch(Operations.loadList('log-category-items'))
    dispatch(Operations.loadList('emar-round-timings'))
  },
  saveSettings: (homeSettings) =>
    dispatch(Operations.saveHomeDetails(homeSettings)),
  openNewRoundTimingModal: () => {
    dispatch(Actions.openModal({ modalId: 'addEmarRoundTimingModal' }))
    dispatch(Actions.addForm({ formId: 'addEmarRoundTimingModal' }))
  },
  deleteRoundTiming: (itemId) => {
    openDialog({
      title: 'Are you sure?',
      type: 'warning',
      text: "This action can't be undone. This medication round time will remain for any existing medications, but you won't be able to choose it for future medications",
      btnLabel: 'Remove',
      onConfirm: () => {
        dispatch(
          Operations.updateListItem({
            listId: 'emar-round-timings',
            successMsg: 'Removed a round timing',
            itemId,
            json: { deleted: true },
          })
        )
      },
    })
  },
})

const wrappedForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(HomeSettingsScreen)

export default Form(wrappedForm, FORM_ID)
